import React, { useEffect, useState } from "react";
import CluppForm from "../../Components/CluppForms/CluppForm";
import useQueryParams from "../../hooks/useQueryParams";
import { useParams } from "react-router-dom";
import setCancelationForm from "./setCancelationForm";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import abandonCancelation from "./abandonCancelation";

const generateRandomId = () => {
  return Math.random().toString(36).substring(2, 16);
};

const CancelationForm = () => {
  const queryParams = useQueryParams();
  const navigate = useNavigate();
  const [showButtons, setShowButtons] = useState(true);
  const [session, setSession] = useState({
    sessionID: "",
    timestampStart: "",
  });
  let { pageId } = useParams();
  const uid = queryParams.get("uid");

  const getSession = () => {
    const sessionID = localStorage.getItem("sessionID");
    const timestampStart = localStorage.getItem("timestampStart");
    const currentTime = new Date().getTime();
    const oneDayInMillis = 24 * 60 * 60 * 1000;

    if (sessionID && timestampStart) {
      const sessionStartTime = new Date(parseInt(timestampStart, 10)).getTime();
      if (currentTime - sessionStartTime > oneDayInMillis) {
        createNewSession();
      } else {
        return { sessionID, timestampStart };
      }
    } else {
      createNewSession();
    }
  };

  const createNewSession = () => {
    const newSessionID = generateRandomId();
    const newTimestampStart = new Date().getTime().toString();
    localStorage.setItem("sessionID", newSessionID);
    localStorage.setItem("timestampStart", newTimestampStart);
    navigate(`/formulario/cancelacion/producto?uid=${uid}`);
  };

  useEffect(() => {
    const session = getSession();
    if (session) {
      setSession(session);
      console.log("Using existing session:", session);
    }
  }, []);

  const { onLoad, onSubmit, content, prevPage, nextPage, fieldsStructure } =
    setCancelationForm({ pageId, uid, navigate });

  return (
    <CluppForm
      isTheFistOne={pageId === "producto" ? true : false}
      onLoad={({ session, landedAt }) =>
        onLoad({ session, landedAt, fieldsStructure, navigate })
      }
      onSubmit={({ state, setLoading }) =>
        onSubmit({
          state,
          session,
          fieldsStructure,
          nextPage,
          navigate,
          setLoading,
        })
      }
      content={({ state, setState, fieldsStructure }) =>
        content({ state, setState, fieldsStructure, setShowButtons })
      }
      nextPage={nextPage}
      prevPage={prevPage}
      session={session}
      userNotFound={!uid}
      actions={({ state, setState, onSubmit, loading }) =>
        showButtons &&
        pageId !== "final" &&
        pageId !== "mantener" &&
        pageId !== "aceptar-descuento" &&
        pageId !== "aceptar-pausa" &&
        pageId !== "error" && pageId !== "error-pausar" &&(
          <>
            {pageId !== "descuento" && pageId !== "pausar" &&  pageId !== "cambiar-periodicidad" && (
              <Button
                disableElevation
                variant="outlined"
                color="primary"
                onClick={() =>
                  abandonCancelation({ session, state, navigate, uid })
                }
                sx={{
                  marginBottom: "10px",
                  textTransform: "none",
                  fontSize: "16px",
                  fontWeight: 600,
                  width: "100%",
                }}
              >
                {"Mantener el seguro"}
              </Button>
            )}
            <Button
              disableElevation
              variant="contained"
              color="primary"
              onClick={onSubmit}
              disabled={loading}
              sx={{
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 600,
                width: "100%",
                backgroundColor: "#DC3434",
                "&:hover": {
                  backgroundColor: "#C82F2F",
                },
              }}
            >
              {"Continuar la cancelación"}
            </Button>
          </>
        )
      }
    />
  );
};

export default CancelationForm;
